import React, { useState, useEffect } from 'react';
import { playSelectSound, playBackgroundMusic } from '../utils/sound';
import './TitleScreen.css';

interface TitleScreenProps {
    onPlayClick: (difficulty: string) => void;
    onHowToPlayClick?: () => void;
}

const TitleScreen: React.FC<TitleScreenProps> = ({ onPlayClick, onHowToPlayClick }) => {
    const [coinCount, setCoinCount] = useState<number>(0);
    const [blinkColon, setBlinkColon] = useState<boolean>(true);
    const [difficulty, setDifficulty] = useState<string>('easy');

    useEffect(() => {
        // Blink the colon every 500ms for the "Insert Coin:" text
        const blinkInterval = setInterval(() => {
            setBlinkColon(prev => !prev);
        }, 500);

        // Load background music when title screen loads but don't autoplay
        // This ensures the music file is loaded and ready if user enables music
        playBackgroundMusic('chiptune', false);

        return () => {
            clearInterval(blinkInterval);
        };
    }, []);

    const handleCoinInsert = () => {
        playSelectSound();
        setCoinCount(prevCount => prevCount + 1);
    };

    const handlePlayClick = () => {
        // if (coinCount > 0) {
        playSelectSound();
        onPlayClick(difficulty);
        // }
    };

    const handleDifficultyChange = (newDifficulty: string) => {
        playSelectSound();
        setDifficulty(newDifficulty);
    };

    return (
        <div className="title-screen">
            <div className="title-container">
                <h1 className="title-text">Pirate Insult Swordfight Simulator</h1>

                {/* <div className="coin-section">
                    <p className="insert-coin-text">
                        Insert Coin{blinkColon ? ':' : ' '}
                        <span className="coin-count">{coinCount > 0 ? coinCount : ''}</span>
                    </p> */}

                    {/* <button
                        className="coin-button nes-btn"
                        onClick={handleCoinInsert}
                        aria-label="Insert Coin"
                    >
                        Insert Coin
                    </button> */}
                {/* </div> */}

                <div className="difficulty-selector">
                    <p className="difficulty-text">Difficulty:</p>
                    <div className="difficulty-buttons">
                        <button
                            className={`nes-btn ${difficulty === 'easy' ? 'is-success' : ''}`}
                            onClick={() => handleDifficultyChange('easy')}
                        >
                            Easy
                        </button>
                        <button
                            className={`nes-btn ${difficulty === 'hard' ? 'is-error' : ''}`}
                            onClick={() => handleDifficultyChange('hard')}
                        >
                            Hard
                        </button>
                    </div>
                </div>

                <div className="title-buttons">
                    <button
                        className={`play-button nes-btn is-primary`}
                        onClick={handlePlayClick}
                    >
                        Play
                    </button>
                    {onHowToPlayClick && (
                        <button
                            className="how-to-play-button nes-btn is-warning"
                            onClick={() => {
                                playSelectSound();
                                onHowToPlayClick();
                            }}
                        >
                            How to Play
                        </button>
                    )}
                </div>
            </div>

            <div className="scanlines"></div>
            <div className="crt-effect"></div>
            <p className="copyright-text">Created by Kush</p>
            <p className="copyright-text">(c) 2025 Interstellar Research</p>
        </div>
    );
};

export default TitleScreen;
